import { Table } from '@chakra-ui/react'
import { Box } from '.'

export default function SimpleTable ({ headers, rows, variant, striped, size, shadow, rounded, asCard }) {
  const table = (
    <Table.Root
      size={size}
      striped={striped || variant === 'striped'}
    >
      <Table.Header>
        <Table.Row bg='bg.subtle'>
          {headers?.map((header, index) => (
            <Table.ColumnHeader key={`${header}-${index}`} color='fg.muted' fontWeight='medium'>{header}</Table.ColumnHeader>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {rows.map((row, index) => (row &&
          <Table.Row key={index}>
            {row?.map((cell, index) => (
              <Table.Cell key={index}>{cell}</Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  )

  if (asCard) {
    return (
      <Box
        overflow='hidden'
        rounded={rounded || 'lg'}
        shadow={shadow || 'md'}
        bg='bg.surface'
        borderWidth='1px'
        borderColor='border.default'
      >
        {table}
      </Box>
    )
  }

  return table
}
